import { HeartIcon, StarIcon, TvIcon } from "@heroicons/react/24/outline";
import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { ReactComponent as WhistleIcon } from "../assets/Whistle.svg";
import { ReactComponent as WhistleRedIcon } from "../assets/Whistle_red.svg";
import Spinner from "../layout/Spinner";
import { compress, decompress } from "../utils/compress";
import { fetchMatches, loadPlayerSensor, updateEventsData, updateMatch } from "../utils/dbutils";
import { getChainData, processTRXFiles } from "../utils/Utils";

function MatchesList() {
  const navigate = useNavigate();
  const [allMatches, setAllMatches] = React.useState([]);
  const [TRXFiles, setTRXFiles] = React.useState(null);
  const [loading, setLoading] = React.useState(false);
  const [loadingMessage, setLoadingMessage] = React.useState("");
  const TRXRef = React.useRef(null);
  const whistle = "";

  const doGenerateEvents = async (m) => {
    console.log("generate events");
    var chains = [];
    setLoading(true);

    const buffer = decompress(m.buffer);
    const evs = processTRXFiles(buffer);
    let plsa = [];
    let plsb = [];
    let evsa = [[], [], [], []];
    let evsb = [[], [], [], []];
    let evsm = [[], [], [], []];
    let matchplsa = [];
    let matchplsb = [];
    for (var e of evs) {
      const period = e["PERIOD"] ? parseInt(e["PERIOD"]) : 0;
      if (e["SQUAD_NAME"] === m.home_squad) {
        if (plsa.filter((p) => p.id === e["PERSON_ID"]).length === 0) {
          const fullname = e["FULLNAME"];
          const plobj = { id: e["PERSON_ID"], name: fullname };
          for (var pl of m.home_athletes) {
            if (
              fullname.toUpperCase().includes(pl.first_name.toUpperCase()) &&
              fullname.toUpperCase().includes(pl.last_name.toUpperCase())
            ) {
              plobj.jersey = pl.jersey;
              plobj.athlete_id = pl.id;
              if (matchplsa.includes(pl) === false) {
                matchplsa.push(pl);
              }
              break;
            }
          }
          plsa.push(plobj);
        }
        if (period > 0) {
          evsa[period - 1].push(e);
          evsm[period - 1].push(e);
        }
      } else if (e["SQUAD_NAME"] === m.away_squad) {
        if (plsb.filter((p) => p.id === e["PERSON_ID"]).length === 0) {
          const fullname = e["FULLNAME"];
          const plobj = { id: e["PERSON_ID"], name: fullname };
          for (var pl of m.away_athletes) {
            if (
              fullname.toUpperCase().includes(pl.first_name.toUpperCase()) &&
              fullname.toUpperCase().includes(pl.last_name.toUpperCase())
            ) {
              plobj.jersey = pl.jersey;
              plobj.athlete_id = pl.id;
              if (matchplsb.includes(pl) === false) {
                matchplsb.push(pl);
              }
              break;
            }
          }
          plsb.push(plobj);
        }
        if (period > 0) {
          evsb[period - 1].push(e);
          evsm[period - 1].push(e);
        }
      }
    }
    if (matchplsa.length < plsa.length) {
      const nomatchplsa = plsa.filter((p) => !p.athlete_id);
      console.log(nomatchplsa);
      let leftoverplsa = [];
      for (var pl of m.home_athletes) {
        if (matchplsa.includes(pl) === false) {
          leftoverplsa.push(pl);
        }
      }
      console.log(leftoverplsa);
      for (var pl of nomatchplsa) {
        const fullname = pl.name;
        for (var plx of leftoverplsa) {
          if (
            fullname.toUpperCase().includes(plx.first_name.toUpperCase()) ||
            fullname.toUpperCase().includes(plx.last_name.toUpperCase())
          ) {
            pl.athlete_id = plx.id;
            pl.jersey = plx.jersey;
            matchplsa.push(plx);
            break;
          }
        }
      }
    }
    if (matchplsa.length < plsa.length) {
      const nomatchplsa = plsa.filter((p) => !p.athlete_id);
      console.log(nomatchplsa);
      let leftoverplsa = [];
      for (var pl of m.home_athletes) {
        if (matchplsa.includes(pl) === false) {
          leftoverplsa.push(pl);
        }
      }
      console.log(leftoverplsa);
      for (var pl of nomatchplsa) {
        const fullname = pl.name;
        for (var plx of leftoverplsa) {
          if (
            fullname.toUpperCase().includes(plx.first_name.toUpperCase()) ||
            fullname.toUpperCase().includes(plx.last_name.toUpperCase())
          ) {
            pl.athlete_id = plx.id;
            pl.jersey = plx.jersey;
            matchplsa.push(plx);
            break;
          }
        }
      }
    }
    if (matchplsa.length < plsa.length) {
      const nomatchplsa = plsa.filter((p) => !p.athlete_id);
      console.log(nomatchplsa);
      let leftoverplsa = [];
      for (var pl of m.home_athletes) {
        if (matchplsa.includes(pl) === false) {
          leftoverplsa.push(pl);
        }
      }
      console.log(leftoverplsa);
      for (var pl of nomatchplsa) {
        const fullname = pl.name;
        for (var plx of leftoverplsa) {
          if (
            fullname.toUpperCase().includes(plx.first_name.toUpperCase()) ||
            fullname.toUpperCase().includes(plx.last_name.toUpperCase())
          ) {
            pl.athlete_id = plx.id;
            pl.jersey = plx.jersey;
            matchplsa.push(plx);
            break;
          }
        }
      }
    }
    if (matchplsb.length < plsb.length) {
      const nomatchplsb = plsb.filter((p) => !p.athlete_id);
      console.log(nomatchplsb);
      let leftoverplsb = [];
      for (var pl of m.away_athletes) {
        if (matchplsb.includes(pl) === false) {
          leftoverplsb.push(pl);
        }
      }
      console.log(leftoverplsb);
      for (var pl of nomatchplsb) {
        const fullname = pl.name;
        for (var plx of leftoverplsb) {
          if (
            fullname.toUpperCase().includes(plx.first_name.toUpperCase()) ||
            fullname.toUpperCase().includes(plx.last_name.toUpperCase())
          ) {
            pl.athlete_id = plx.id;
            pl.jersey = plx.jersey;
            matchplsb.push(plx);
            break;
          }
        }
      }
    }
    if (!m.periods) {
      m.periods = [];
      for (var p = 1; p <= 4; p++) {
        m.periods.push({
          period: p,
          // events: evsm[p - 1],
        });
      }
    }
    // setLoading(false);
    // setFirstBounceVideoTime(
    //   parseFloat(m.periods[selectedPeriod - 1].firstBounceVideoTime) || 0
    // );
    // setCatapultOffset(m.periods[selectedPeriod - 1].catapultOffset || 0);
    // setVideo1Url(m.periods[selectedPeriod - 1].video1Url || "");
    // setVideo2Url(m.periods[selectedPeriod - 1].video2Url || "");

    const ta = {
      catapultPlayers: structuredClone(m.home_athletes),
      cdplayers: plsa,
      name: m.home_squad,
      show: true,
      events: evsa,
    };
    // setTeamA(ta);
    const tb = {
      catapultPlayers: structuredClone(m.away_athletes),
      cdplayers: plsb,
      name: m.away_squad,
      show: true,
      events: evsb,
    };
    // setTeamB(tb);

    const nperiods = 4;
    for (var np = 0; np < nperiods; np++) {
      setLoadingMessage(
        `Loading Quarter ${np + 1} sensor data for ${m.home_squad}...`
      );
      await loadPlayerSensor(m, ta, np + 1);
      setLoadingMessage(
        `Loading Quarter ${np + 1} sensor data for ${m.away_squad}...`
      );
      await loadPlayerSensor(m, tb, np + 1);
      if (m.umpires) {
        const tu = {
          catapultPlayers: structuredClone(m.umpires),
          cdplayers: [],
          name: "AFL Umpires",
          show: true,
          events: [[], [], [], []],
        };
        setLoadingMessage(
          `Loading Quarter ${np + 1} sensor data for umpires...`
        );
        await loadPlayerSensor(m, tu, np + 1);
      }
    }
    setLoadingMessage("Generating events...");
    const codes = [
      "GOAL",
      "BEHI",
      "FRAGP",
      "FRABB",
      "FRAG",
      "FRAGN",
      "FRAGO",
      "FRFOB",
      "FRFNO",
      "FRFO",
      "FRFBB"
    ];
    const teams = [ta, tb];
    for (var tm of teams) {
      for (var p = 0; p < nperiods; p++) {
        const evs = tm.events[p];
        for (var e of evs) {
          if (codes.includes(e["STATISTIC_CODE"])) {
            const chain = getChainData(e, tm, m);
            if (chain) {
              chain.period = p + 1;
              chain.code = e["STATISTIC_CODE"];
              chains.push(chain);
            }
          }
        }
      }
    }
    const zipchaindata = compress(JSON.stringify(chains));
    const chaindata = { matchId: m.matchId, data: zipchaindata };
    console.log(zipchaindata.length);
    await updateEventsData(chaindata);
    setLoading(false);
  };

  const doMatch = async (m) => {
    const st = { match: m };
    navigate("/matchtracker", { state: st });
  };

  const doGetCatapultData = async (m, team) => {
    const st = { match: m, team: team };
    navigate("/catapultsessions", { state: st });
  };

  const doClearAll = (clear) => {
    if (clear) {
      setTRXFiles(null);
      TRXRef.current.value = null;
    }
  };

  const handleTRXFileSelected = (event) => {
    const files = event.target.files;
    var mobjs = [];
    for (var nf = 0; nf < files.length; nf++) {
      const fileReader = new FileReader();
      fileReader.readAsText(files[nf], "UTF-8");
      const filename = files[nf].name;
      fileReader.onload = async (e) => {
        const evs = processTRXFiles(e.target.result);
        const comp = compress(e.target.result);
        const m = {
          matchId: evs[0]["FIXED_ID"],
          matchDate: evs[0]["MATCH_DATE"],
          matchTime: evs[0]["MATCH_TIME"],
          seasonId: evs[0]["SEASON_ID"],
          groupRoundNo: evs[0]["GROUP_ROUND_NO"],
          venue: evs[0]["VENUE_NAME"],
          venueWidth: evs[0]["VENUE_WIDTH"],
          venueLength: evs[0]["VENUE_LENGTH"],
          home_squad: evs[0]["HOME_SQUAD"],
          away_squad: evs[0]["AWAY_SQUAD"],
          buffer: comp,
        };
        await updateMatch(m);
      };
    }
  };

  const doInit = async () => {
    const ms = await fetchMatches();
    if (ms) {
      setAllMatches(ms);
    }
  };

  useEffect(() => {
    doInit();
  }, []);

  if (loading) {
    return <Spinner message={loadingMessage} />;
  }

  return (
    <>
      <div className="flex flex-col">
        <div className="flex my-4">
          <input
            type="file"
            id="selectedTRXFiles"
            ref={TRXRef}
            style={{ display: "none" }}
            onChange={handleTRXFileSelected}
            onClick={(event) => {
              event.target.value = null;
            }}
            multiple
          />
          <input
            type="button"
            className="btn-in-form"
            value="Select TRX files..."
            onClick={() => document.getElementById("selectedTRXFiles").click()}
          />
          <label className="label ml-4">
            <span className="label-text">
              {TRXFiles === null || TRXFiles.length === 0
                ? "Please select TRX files to import"
                : TRXFiles.length + " TRX files selected"}
            </span>
          </label>
          <button className="btn-in-form ml-4" onClick={() => doClearAll(true)}>
            Clear All
          </button>
        </div>
      </div>
      <div className="-mx-4 -my-2 overflow-x-auto sm:-mx-6 lg:-mx-8 h-[70vh] overflow-auto">
        <div className="inline-block min-w-full py-2 align-middle sm:px-6 lg:px-8">
          <table className="table-generic">
            <thead className="thead-generic">
              <tr className="tr-generic">
                <th scope="col" className="th-generic">
                  Team A
                </th>
                <th scope="col" className="th-generic"></th>
                <th scope="col" className="th-generic">
                  Team B
                </th>
                <th scope="col" className="th-generic"></th>
                <th scope="col" className="th-generic">
                  Date
                </th>
                <th scope="col" className="th-generic">
                  Venue
                </th>
                <th scope="col" className="th-generic"></th>
                <th scope="col" className="th-generic"></th>
                <th scope="col" className="th-generic"></th>
              </tr>
            </thead>
            <tbody className="tbody-generic">
              {allMatches &&
                allMatches.map((m, idx) => (
                  <tr
                    key={idx}
                    className={idx % 2 !== 0 ? "bg-black/5" : "bg-white/5"}
                  >
                    <td className="td-generic">
                      <div className="flex gap-2">{m.home_squad}</div>
                    </td>
                    <td className="td-generic">
                      <HeartIcon
                        className={
                          m.home_catapult_session
                            ? "h-6 w-6 text-red-600 cursor-pointer"
                            : "h-6 w-6 text-base-content cursor-pointer"
                        }
                        onClick={() => {
                          doGetCatapultData(m, m.home_squad);
                        }}
                      />
                    </td>
                    <td className="td-generic">
                      <div className="flex gap-2">{m.away_squad}</div>
                    </td>
                    <td className="td-generic">
                      <HeartIcon
                        className={
                          m.away_catapult_session
                            ? "h-6 w-6 text-red-600 cursor-pointer"
                            : "h-6 w-6 text-base-content cursor-pointer"
                        }
                        onClick={() => {
                          doGetCatapultData(m, m.away_squad);
                        }}
                      />
                    </td>
                    <td className="td-generic">{m.matchDate}</td>
                    <td className="td-generic">{m.venue}</td>
                    <td>
                      {m.umpires ? (
                        <WhistleRedIcon
                          className="h-6 w-6 text-base-content cursor-pointer"
                          onClick={() => {
                            doGetCatapultData(m, "AFL Umpires");
                          }}
                        />
                      ) : (
                        <WhistleIcon
                          className="h-6 w-6 text-base-content cursor-pointer"
                          onClick={() => {
                            doGetCatapultData(m, "AFL Umpires");
                          }}
                        />
                      )}
                    </td>
                    <td>
                      <StarIcon
                        className="h-6 w-6 mt-2 text-base-content cursor-pointer"
                        onClick={() => {
                          doGenerateEvents(m);
                        }}
                      />
                    </td>
                    <td>
                      <TvIcon
                        className="h-6 w-6 mt-2 text-base-content cursor-pointer"
                        onClick={() => {
                          doMatch(m);
                        }}
                      />
                    </td>
                  </tr>
                ))}
            </tbody>
          </table>
        </div>
      </div>
    </>
  );
}

export default MatchesList;
